import {
  ADVANCED,
  MODE_PARAM,
  MODE_PARAMS,
  omitFilterParams,
  removeFilterParam,
} from "../../../components/filters/OpportunitySearchFilter/filterConfig"

// Must match SEARCH_PER_PAGE in the API opportunities controller.
const PAGE_SIZE = 8

export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY"
export const SET_SEARCH_PAGE = "SET_SEARCH_PAGE"
export const SET_FORM_FILTERS = "SET_FORM_FILTERS"
export const SET_TAB_FILTER = "SET_TAB_FILTER"
export const RESET_FORM_FILTERS = "RESET_FORM_FILTERS"
export const REMOVE_FILTER = "REMOVE_FILTER"
export const SET_SEARCH_PARAMS = "SET_SEARCH_PARAMS"
export const SET_REQUEST_RESULT = "SET_REQUEST_RESULT"

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case SET_SEARCH_QUERY: {
      const { query } = payload
      return {
        ...state,
        searchParamGroup: { ...state.searchParamGroup, query, page: 1 },
      }
    }
    case SET_SEARCH_PAGE: {
      const { pageNumber } = payload
      return {
        ...state,
        searchParamGroup: { ...state.searchParamGroup, page: pageNumber },
      }
    }
    case SET_TAB_FILTER: {
      // Type tabs belong to the Core filters, so they clear Advanced ones.
      const { opportunityType } = payload
      return {
        ...state,
        searchParamGroup: {
          ...omitFilterParams(state.searchParamGroup, [
            ...MODE_PARAMS[ADVANCED],
            MODE_PARAM,
          ]),
          opportunity_type: opportunityType ? opportunityType : "",
          page: 1,
        },
      }
    }
    case SET_FORM_FILTERS: {
      // Params of the active filter tab only; anything applied before is replaced.
      const { params } = payload
      return {
        ...state,
        searchParamGroup: {
          ...omitFilterParams(state.searchParamGroup),
          ...params,
          page: 1,
        },
      }
    }
    case RESET_FORM_FILTERS: {
      return {
        ...state,
        searchParamGroup: {
          ...omitFilterParams(state.searchParamGroup),
          page: 1,
        },
      }
    }
    case REMOVE_FILTER: {
      const { param, value } = payload
      return {
        ...state,
        searchParamGroup: {
          ...removeFilterParam(state.searchParamGroup, param, value),
          page: 1,
        },
      }
    }
    case SET_SEARCH_PARAMS: {
      const { locationSearchGroup } = payload
      return {
        ...state,
        searchParamGroup: {
          // ...state.searchParamGroup,
          ...locationSearchGroup,
        },
      }
    }
    case SET_REQUEST_RESULT: {
      const { data, locationSearchGroup } = payload
      const dataTotalCount = data.total_count || 0
      return {
        ...state,
        requestResultGroup: {
          opportunityList: data.opportunities || [],
          opportunityCount: dataTotalCount,
          pageCount: Math.ceil(dataTotalCount / PAGE_SIZE),
          page: 1,
          query: "",
          ...locationSearchGroup,
        },
      }
    }
    default:
      throw Error("Unknown action type")
  }
}
